import assignmentPagesData from "./assignmentPages.json";
import { AssignmentPageData } from "../types/assignmentPage";
import { normalizeInternalHref } from "../utils/routes";

function validateAssignmentPage(page: AssignmentPageData) {
  const requiredStringFields: Array<keyof AssignmentPageData> = [
    "slug",
    "subject",
    "title",
    "category",
    "categoryDescription",
    "categoryHref",
    "metaTitle",
    "metaDescription",
    "intro",
    "whatIs",
    "commonQuestions",
    "whyChoose",
  ];

  const hasEmptyString = requiredStringFields.some(
    (field) => !String(page[field] || "").trim(),
  );

  if (hasEmptyString) {
    return false;
  }

  if (
    !page.topics.length ||
    !page.supportSteps.length ||
    !page.assignmentTypes.length ||
    !page.relatedSubjects.length ||
    page.faqs.length < 4
  ) {
    return false;
  }

  return true;
}

const rawAssignmentPages = assignmentPagesData as AssignmentPageData[];

const normalizedAssignmentPages = rawAssignmentPages.map((page) => ({
  ...page,
  categoryHref: normalizeInternalHref(page.categoryHref),
  relatedSubjects: page.relatedSubjects.map((subject) => ({
    ...subject,
    href: normalizeInternalHref(subject.href),
  })),
  sitelinks: page.sitelinks?.map((sitelink) => ({
    ...sitelink,
    href: sitelink.href?.startsWith("#")
      ? sitelink.href
      : normalizeInternalHref(sitelink.href),
  })),
}));

export const assignmentPages = normalizedAssignmentPages.filter((page) => {
  const isValid = validateAssignmentPage(page);

  if (!isValid) {
    // eslint-disable-next-line no-console
    console.warn(`Invalid assignment page data skipped: ${page.slug}`);
  }

  return isValid;
});

export function getAssignmentPageBySlug(slug?: string) {
  return assignmentPages.find((page) => page.slug === slug);
}

export function getAssignmentPageRoutes() {
  return assignmentPages.map((page) => ({
    path: page.slug,
    label: page.title,
  }));
}
